import React from 'react';
import { useField, connect } from 'formik';

import { RadioButtons, PillSelect, FormLabel as Label } from '~ui-kit';
import Error from '../components/Error';
import FieldContextFeeder from '../components/FieldContextFeeder';

const RadioButtonField = ({ children, ...props }) => {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;
  const { setFieldValue } = props.formik;

  return (
    <div>
      <Label
        htmlFor={props.id || props.name}
        info={props.info}
        required={props.required}
      >
        {props.label}
      </Label>
      {props.pills ? (
        <PillSelect
          {...field}
          {...props}
          name={field.name}
          onChange={value => setFieldValue(props.name, value)}
        />
      ) : (
        <RadioButtons
          {...field}
          {...props}
          error={error}
          onChange={value => {
            setFieldValue(props.name, value)
            if (props.onChange) 
              props.onChange(value);
            }
          }
        />
      )}
      {error ? <Error>{meta.error}</Error> : null}
    </div>
  );
};

export default FieldContextFeeder(connect(RadioButtonField));
